export const Death = require("./Death.png");
export const Devil = require("./Devil.png");
export const HangedMan = require("./HangedMan.png");
export const Judgement = require("./Judgement.png");
export const Justice = require("./Justice.png");
export const Moon = require("./Moon.png");
export const Star = require("./Star.png");
export const Sun = require("./Sun.png");
export const Temperance = require("./Temperance.png");
export const Tower = require("./Tower.png");
